import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ConversationDetailsData } from './conversation-details.interface';
import { formatDigitsOnlyToPhoneNumber } from 'src/app/utils/strings/string.utils';

@Component({
  selector: 'app-voice-ai-conversation-details',
  templateUrl: './conversation-details.component.html',
  styleUrls: ['./conversation-details.component.scss'],
})
export class ConversationDetailsComponent implements OnChanges {
  @Input() conversationDetails?: ConversationDetailsData;
  formattedNumber: string = '';

  ngOnChanges(changes: SimpleChanges) {
    const cd = changes['conversationDetails']?.currentValue as ConversationDetailsData | undefined;
    if (!cd) return;

    const digits = (cd.customerPhone ?? '').replace(/\D+/g, '');
    this.formattedNumber = digits ? formatDigitsOnlyToPhoneNumber(digits) : '–';
  }
}
